// // YouTubeEmbed.js
// import React from 'react';
// import './video.css'

// const YouTubeEmbed = ({ videoId }) => {
//   const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;

//   return (
//     <div className="video-responsive">
//       <iframe
//         width="560"
//         height="315"
//         src={embedUrl}
//         title={`YouTube video player ${videoId}`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//         referrerPolicy="strict-origin-when-cross-origin"
//         allowFullScreen
//       ></iframe>
//     </div>
//   );
// };

// export default YouTubeEmbed;



// LocalVideoEmbed.js
import React from 'react';
import './video.css';

const LocalVideoEmbed = ({ videoId }) => {
  const videoUrl = `${videoId}`; // Path to the video file in the public folder

  return (
    <div className="video-responsive">
      <video
        width="560"
        height="315"
        src={videoUrl}
        autoPlay
        muted
        // controls
      />
    </div>
  );
};

export default LocalVideoEmbed;
